import { FC } from "react";

export const DownloadIcon: FC = () => {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 6.3513V10.8493H10.5V6.3493M8.25 6.0993L6 8.3493L3.75 6.0993M5.998 1.8493V8.3493" stroke="red" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
